export enum LoadingState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  LOADING_LAZY = 'LOADING_LAZY',
  SAVING = 'SAVING',
}
